import { useMemo } from 'react';
import type { Mdd, MddLot } from '../types.js';
import mddData from '@trace/mdd';

export function useMdd(): Mdd {
  return useMemo(() => mddData as Mdd, []);
}

export function useLot(lotCode: string): MddLot | undefined {
  const mdd = useMdd();
  return useMemo(() => mdd.lots.find(l => l.code === lotCode), [mdd, lotCode]);
}

export const LOT_ICONS: Record<string, string> = {
  cadrage: '🎯', site_donnees: '📍', etudes: '📐', production_pv: '☀️',
  structure: '🏗️', conversion_elec: '⚡', stockage_bess: '🔋',
  ems_supervision: '🖥️', usages_pilotes: '🔌', acc_reglementaire: '📋',
  execution: '🔧', maintenance: '🛡️',
};
